import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const TabPanel = (props) => {
  const { children, value, index, paddingTop, paddingBottom, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      display={value === index ? 'flex' : undefined}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{
        flex: 1,
        flexDirection: 'column',
        overflow: 'auto',
        px: 0,
        paddingTop: props.paddingTop ?? 3,
        paddingBottom: props.paddingBottom ?? 3
      }}
      {...other}
    >
      {value === index && <>{children}</>}
    </Box>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
};

export const a11yTabProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

export default TabPanel;
